export const trimFields = (element) => {
    if (typeof element === 'object' && element !== null && !Array.isArray(element)) {
        return {
            ...element,
            ...(element?.numerator ? { numerator: element.numerator.trim() ?? element.numerator } : {}),
            ...(element?.denominator ? { denominator: element.denominator.trim() ?? element.denominator } : {}),
            ...(typeof element?.value === 'string' ? { value: element.value.trim() ?? element.value } : {}),
            ...(element?.degree ? { degree: element.degree.trim() ?? element.degree } : {}),
        };
    }
    return element;
};